const getRelativeOffset = (
  anchor: { getBoundingClientRect: () => DOMRect },
  el: { getBoundingClientRect: () => DOMRect }
): Pick<DOMRect, 'x' | 'y'> => {
  const anchorRect = anchor.getBoundingClientRect();
  const elRect = el.getBoundingClientRect();

  const x = anchorRect.x - elRect.x;
  const y = anchorRect.y - elRect.y;

  return { x, y };
};

export default getRelativeOffset;
